<!-- <sm-svg-loader *ngIf="loader"></sm-svg-loader> -->

<!-- Mobile design start-->
<div class="">
  <div class="booking_card_open">
    <mat-card (click)="viewAll()">
      <div class="header_cardf_drd">
        <div class="todays_booking_logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="512"
            height="512"
            x="0"
            y="0"
            viewBox="0 0 682.667 682.667"
            style="enable-background: new 0 0 512 512"
            xml:space="preserve"
            class=""
          >
            <g>
              <defs>
                <clipPath id="a" clipPathUnits="userSpaceOnUse">
                  <path
                    d="M0 512h512V0H0Z"
                    fill="#098c09"
                    opacity="1"
                    data-original="#000000"
                  ></path>
                </clipPath>
              </defs>
              <g
                clip-path="url(#a)"
                transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
              >
                <path
                  d="M0 0h223.522c12.296 0 22.264 9.968 22.264 22.264v86.309"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(232.593 52.338)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-60.689c-12.296 0-22.264-9.968-22.264-22.264V-169.66"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(208.911 504.5)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0v287.147c0 12.296-9.968 22.264-22.264 22.264H-235.29"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(478.379 195.089)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M435.2 377.006H169.138v73.718H435.2Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0a14.318 14.318 0 0 0 12.391 7.131h18.57c7.912 0 14.326-6.414 14.326-14.326 0-7.912-6.414-14.326-14.326-14.326h-12.57"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(244.538 321.791)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.414-14.326 14.326 0 7.912 6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.414 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(347.41 300.27)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.414-14.326 14.326 0 7.912 6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.414 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(419.32 300.27)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h14.57c7.912 0 14.326-6.414 14.326-14.326 0-7.912-6.414-14.326-14.326-14.326H-4c-7.912 0-14.326 6.414-14.326 14.326"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(260.929 255.996)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.414-14.326 14.326 0 7.912 6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.414 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(347.41 227.343)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.414-14.326 14.326 0 7.912 6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.414 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(419.32 227.343)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0v0c0 7.912 6.414 14.326 14.326 14.326h18.57c7.913 0 14.327-6.414 14.327-14.326 0-7.912-6.414-14.327-14.327-14.327h-16.57"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(242.602 183.069)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.415-14.326 14.327s6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.415 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(347.41 168.742)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.415-14.326 14.327s6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.415 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(419.32 168.742)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h12.57c7.912 0 14.326-6.414 14.326-14.326 0-7.912-6.414-14.327-14.326-14.327H-4"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(262.929 138.794)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.415-14.326 14.327s6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.415 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(347.41 110.142)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-18.57c-7.912 0-14.326 6.415-14.326 14.327s6.414 14.326 14.326 14.326H0c7.912 0 14.326-6.414 14.326-14.326C14.326 6.415 7.912 0 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(419.32 110.142)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0v-41.878c0-15.808 34.533-28.977 80.291-31.901"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(33.62 81.886)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0c47.836 2.361 84.504 15.852 84.504 32.141v41.878"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(148.089 7.867)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0c3.864-3.469 5.972-7.213 5.972-11.119 0-17.953-44.542-32.507-99.487-32.507-54.944 0-99.486 14.554-99.486 32.507 0 9.681 12.95 18.373 33.498 24.328"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(226.622 93.004)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0v-41.878c0-17.954 44.542-32.507 99.486-32.507 54.945 0 99.487 14.553 99.487 32.507V0"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(61.892 160.733)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0c20.773-5.958 33.886-14.698 33.886-24.44 0-17.953-44.542-32.507-99.486-32.507-54.945 0-99.486 14.554-99.486 32.507 0 3.962 2.169 7.759 6.141 11.27"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(226.978 185.173)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0v-41.878c0-17.954 44.542-32.508 99.486-32.508 54.945 0 99.487 14.554 99.487 32.508v38.554"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(33.62 239.58)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0c-5.095-16.392-47.462-29.184-98.973-29.184-54.944 0-99.486 14.554-99.486 32.508 0 8.343 9.618 15.951 25.429 21.707"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(232.08 236.257)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0v-41.878c0-17.954 44.542-32.508 99.486-32.508 54.945 0 99.487 14.554 99.487 32.508V0"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(61.892 302.332)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0c0-17.953-44.542-32.507-99.486-32.507-54.945 0-99.487 14.554-99.487 32.507 0 17.954 44.542 32.508 99.487 32.508C-44.542 32.508 0 17.954 0 0Z"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(260.864 302.332)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h25.358"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(68.814 356.426)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h25.358"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(68.814 379.666)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
                <path
                  d="M0 0h-.1"
                  style="
                    stroke-width: 15;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: none;
                    stroke-opacity: 1;
                  "
                  transform="translate(94.222 405.45)"
                  fill="none"
                  stroke="#098c09"
                  stroke-width="15"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-dasharray="none"
                  stroke-opacity=""
                  data-original="#000000"
                  class=""
                  opacity="1"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <div class="todays_parat">
          <h3 *ngIf="!loader">
            {{
              unpaidInvoicesData?.total_unpaid_invoices
                ? unpaidInvoicesData?.total_unpaid_invoices
                : 0
            }}
          </h3>
          <svg
            *ngIf="loader"
            class="cust_svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="margin: auto; background: transparent; display: block"
            width="54px"
            height="54px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
          >
            <g transform="rotate(0 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.9166666666666666s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(30 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.8333333333333334s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(60 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.75s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(90 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.6666666666666666s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(120 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.5833333333333334s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(150 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.5s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(180 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.4166666666666667s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(210 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.3333333333333333s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(240 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.25s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(270 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.16666666666666666s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(300 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="-0.08333333333333333s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(330 50 50)">
              <rect
                x="47"
                y="24"
                rx="3"
                ry="6"
                width="6"
                height="12"
                fill="#f20c49"
              >
                <animate
                  attributeName="opacity"
                  values="1;0"
                  keyTimes="0;1"
                  dur="1s"
                  begin="0s"
                  repeatCount="indefinite"
                ></animate>
              </rect>
            </g>
          </svg>
        </div>
      </div>
      <div class="apploint_set_prp">
        <h3>Unpaid Bills/Invoices</h3>
        <p>
          Services:
          {{
            (unpaidInvoicesData?.total_unpaid_bookings
              ? unpaidInvoicesData?.total_unpaid_bookings
              : 0) + (unpaidInvoicesData?.total_unpaid_membership
              ? unpaidInvoicesData?.total_unpaid_membership
              : 0)
          }}
        </p>
        <!-- <p>Memberships: {{unpaidInvoicesData?.total_unpaid_membership ? unpaidInvoicesData?.total_unpaid_membership : 0}}</p> -->
        <p>
          Others:
          {{
            unpaidInvoicesData?.total_unpaid_others
              ? unpaidInvoicesData?.total_unpaid_others
              : 0
          }}
        </p>
      </div>
      <div
        class="arrow_crdf"
        *ngIf="unpaidInvoicesData?.total_unpaid_invoices > 0"
      >
        <mat-icon>arrow_forward</mat-icon>
      </div>
    </mat-card>
  </div>
</div>
<!-- Mobile design end-->
